import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-feedback-header',
    templateUrl: './feedback-header.component.html',
    styleUrls: ['./feedback-header.component.scss'],
    standalone: false
})
export class FeedbackHeaderComponent {
  @Input() feedback: any;
  @Input() title: string = 'Response Feedback';
  @Input() showButton: boolean = true;
  @Input() buttonText: string = 'Show Details';
  @Input() buttonClass: string = 'btn-conversation';
  @Input() headerData: any;
  @Output() backClick = new EventEmitter<void>();
  @Output() buttonClick = new EventEmitter<void>();
  @Output() showConversationClick = new EventEmitter<void>();
  @Output() assignClick = new EventEmitter<void>();

  get displayData(): any {
    return this.headerData || this.feedback;
  }

  get formattedDate(): string | null {
    const value = this.displayData?.submittedOn || this.displayData?.created_date;
    if (!value) return null;

    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : this.formatDate(value);
    }

    return this.convertUtcToLocal(value);
  }

  convertUtcToLocal(utcDateString: string): string | null {
    if (!utcDateString || typeof utcDateString !== 'string') return null;
    const utcDate = utcDateString.includes('.')
      ? utcDateString.split('.')[0] + 'Z'
      : utcDateString.endsWith('Z') ? utcDateString : utcDateString + 'Z';
    const localDate = new Date(utcDate);
    if (isNaN(localDate.getTime())) return null;
    return this.formatDate(localDate);
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate());
    const year = date.getFullYear();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthShort = monthNames[date.getMonth()] || '';

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day} ${monthShort} ${year} ${hours}:${minutes}${ampm}`;
  }

  goBack(): void {
    this.backClick.emit();
  }

  onButtonClick(): void {
    this.buttonClick.emit();
    this.showConversationClick.emit();
  }

  onAssignClick(): void {
    this.assignClick.emit();
  }
}
